module.exports = __webpack_public_path__ + "static/media/4.d2dcac62.png";